<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3">
        <b-col><h1>Clientes</h1></b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Buscar (nombre, teléfono, email, uuid, código)">
            <b-form-input v-model="filters.q" debounce="500" @update="reload"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Fuente">
            <b-form-select v-model="filters.source" :options="sourceOptions" @change="reload"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Estado">
            <b-form-select v-model="filters.status" :options="statusOptions" @change="reload"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Compra">
            <b-form-select v-model="filters.has_purchase" :options="purchaseOptions" @change="reload"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Nivel (código)">
            <b-form-input v-model="filters.tier" debounce="500" @update="reload"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table small striped hover responsive :items="customers" :fields="fields" :busy="loading">
            <template #table-busy>
              <div class="text-center my-2"><b-spinner></b-spinner></div>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="warning" @click="$router.push('/customers/' + data.item.id)">Ver ficha</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-pagination v-model="page" :total-rows="total" :per-page="limit" @change="onPage"></b-pagination>
          <small class="text-muted">{{ total }} clientes</small>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Nav from "../components/Nav.vue";
import customersService from "../services/customersService";

export default {
  name: "clientes",
  components: { Nav },
  data() {
    return {
      customers: [],
      total: 0,
      page: 1,
      limit: 50,
      loading: false,
      filters: { q: "", source: "", status: "", has_purchase: "", tier: "" },
      sourceOptions: [
        { value: "", text: "Todas" },
        { value: "app", text: "App" },
        { value: "pos", text: "POS" },
        { value: "qr_sucursal", text: "QR sucursal" },
        { value: "campaign", text: "Campaña" },
        { value: "referral", text: "Referido" },
        { value: "import", text: "Importación" },
      ],
      statusOptions: [
        { value: "", text: "Todos" },
        { value: "active", text: "Activo" },
        { value: "blocked", text: "Bloqueado" },
        { value: "deleted", text: "Eliminado" },
      ],
      purchaseOptions: [
        { value: "", text: "Todos" },
        { value: "1", text: "Con compra" },
        { value: "0", text: "Sin compra" },
      ],
      fields: [
        { key: "id", label: "ID" },
        { key: "name", label: "Nombre" },
        { key: "phone", label: "Teléfono" },
        { key: "email", label: "Email" },
        { key: "referral_code", label: "Código" },
        { key: "registration_source", label: "Fuente" },
        { key: "status", label: "Estado" },
        { key: "buttons", label: "" },
      ],
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.page = 1;
      this.load();
    },
    onPage(p) {
      this.page = p;
      this.load();
    },
    load() {
      this.loading = true;
      const params = { limit: this.limit, offset: (this.page - 1) * this.limit };
      Object.keys(this.filters).forEach((k) => {
        if (this.filters[k] !== "" && this.filters[k] !== null) params[k] = this.filters[k];
      });
      customersService
        .search(params)
        .then((res) => {
          this.customers = res.data.customers || [];
          this.total = res.data.total || 0;
        })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loading = false));
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
